/**
 * Grille compacte U3129 (BL-0672) — honoraires en priorité.
 * Hauteur ~32px (h-8) vs 46px legacy sur les autres onglets.
 */

/** Padding vertical minimal entre les lignes du tbody honoraires. */
export const U3129_GRID_COMPACT_ROW_CELL_PY = "py-0.5";

/** Pied de tableau : +5 px d’air entre les lignes de totaux (`2.5px` haut + bas par cellule). */
export const U3129_GRID_COMPACT_FOOTER_ROW_PY = "py-[2.5px]";

/** Gutter honoraires : chevron + case de sélection projet (BL-0686). */
export const U3129_HONORARIUM_COL_WIDTH_GUTTER = "4.75rem";

export const U3129_HONORARIUM_GUTTER_TD_CLASS = `min-w-[4.75rem] w-[4.75rem] max-w-[4.75rem] shrink-0 pl-1 pr-1 ${U3129_GRID_COMPACT_ROW_CELL_PY} align-middle`;

export const U3129_GRID_COMPACT_ROW_CHECKBOX_TD_CLASS = `w-10 px-1 ${U3129_GRID_COMPACT_ROW_CELL_PY} align-middle [&>div.flex]:box-border [&>div.flex]:min-h-8 [&>div.flex]:w-full [&>div.flex]:items-center [&>div.flex]:justify-center [&>div.flex]:gap-0 [&>div.flex>label:last-child:empty]:hidden`;

/** Colonnes jour + total : padding cellule tbody (`px-1`). */
export const U3129_GRID_COMPACT_HOUR_COLUMN_CELL_X = "px-1";

/** Honoraires — colonnes projet / client / sous-projet : même écart horizontal que les jours. */
export const U3129_HONORARIUM_META_COLUMN_CELL_X = U3129_GRID_COMPACT_HOUR_COLUMN_CELL_X;

/** Cellule tâche regroupée (colspan projet + client [+ sous-projet]) — même inset horizontal que les meta. */
export const U3129_HONORARIUM_TASK_DETAIL_TD_BASE = `${U3129_HONORARIUM_META_COLUMN_CELL_X} ${U3129_GRID_COMPACT_ROW_CELL_PY}`;

/** Ligne tâche (accordéon) : libellé tâche ~66 %, natures ~33 % dans le bloc projet+client+natures. */
export const U3129_HONORARIUM_TASK_ROW_SPLIT_WRAPPER_CLASS = "flex w-full min-w-0 items-stretch gap-1";
export const U3129_HONORARIUM_TASK_ROW_TASK_PART_CLASS =
  "flex min-h-8 min-w-0 basis-2/3 shrink self-stretch whitespace-normal break-words leading-tight";
export const U3129_HONORARIUM_TASK_ROW_NATURE_PART_CLASS =
  "flex min-h-8 min-w-0 basis-1/3 self-stretch tabular-nums text-left whitespace-normal break-all leading-tight";
/** Colspan meta sur une ligne tâche : colonnes Projet + Client + Natures. */
export const U3129_HONORARIUM_TASK_ROW_META_COLSPAN = 3;

/**
 * Dossier déplié : la ligne projet (parent) et ses lignes tâche / sous-projet (enfants) forment un bloc visuel —
 * même teinte de fond et barre d’accent à gauche ; boîtes lecture blanches dans les enfants pour garder le contraste.
 */
export const U3129_HONORARIUM_EXPANDED_PARENT_ROW_CLASS = "bg-blue-50 hover:bg-blue-100/70";
export const U3129_HONORARIUM_COLLAPSED_PARENT_ROW_CLASS = "bg-slate-50/90 hover:bg-slate-100";
/** Ligne projet cliquable (déplier / replier) : curseur main, y compris sur les boîtes lecture (`cursor-not-allowed`). */
export const U3129_HONORARIUM_CLICKABLE_PARENT_ROW_CLASS = "cursor-pointer [&_*]:cursor-pointer!";
export const U3129_HONORARIUM_EXPANDED_CHILD_ROW_CLASS = "border-b border-blue-100 bg-blue-50/50 hover:bg-blue-50";
export const U3129_HONORARIUM_EXPANDED_SUBPROJECT_ROW_CLASS = "border-b border-blue-100 bg-blue-100/40";
/** Barre d’accent sur la première cellule (ombre interne : compatible `border-collapse`). */
export const U3129_HONORARIUM_EXPANDED_ACCENT_CELL_CLASS = "shadow-[inset_4px_0_0_0_#3b82f6]";
/** Mode lecture uniquement : en édition, le gris des cellules non modifiables doit rester distinct des champs de saisie. */
export const U3129_HONORARIUM_EXPANDED_CHILD_BOX_CLASS = "bg-white! border-blue-100!";

export const U3129_GRID_COMPACT_ROW_HOUR_TD_BASE = `${U3129_GRID_COMPACT_HOUR_COLUMN_CELL_X} ${U3129_GRID_COMPACT_ROW_CELL_PY}`;

/** Conteneur pleine largeur de colonne (tbody), même niveau que le wrapper autour de U2000InputDecimal. */
export const U3129_GRID_COMPACT_HOUR_CELL_INNER_CLASS = "w-full min-w-0";

const U3129_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_BASE = `pl-1 ${U3129_GRID_COMPACT_FOOTER_ROW_PY} align-top text-right text-sm tabular-nums leading-none`;

/** Lecture / lignes readonly : −4 px pour aligner sur les boîtes compactes. */
export const U3129_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_CLASS_READ = `${U3129_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_BASE} pr-[calc(0.25rem+0.75rem+1px-4px)]`;

/** Édition (inputs actifs) : inset sans le décalage −4 px. */
export const U3129_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_CLASS_EDIT = `${U3129_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_BASE} pr-[calc(0.25rem+0.75rem+1px+2px)]`;

/** En-tête colonnes jour (même inset droit que le détail). */
export const U3129_GRID_COMPACT_HOUR_HEADER_INNER_CLASS =
  "box-border flex w-full min-w-0 items-center justify-end gap-0.5 rounded-lg border border-transparent px-4 text-right text-sm tabular-nums leading-tight";

export const U3129_GRID_COMPACT_ROW_TASK_TD_BASE = `px-3 ${U3129_GRID_COMPACT_ROW_CELL_PY}`;

export const U3129_GRID_COMPACT_FOOTER_GUTTER_TD_CLASS = `${U3129_HONORARIUM_GUTTER_TD_CLASS} ${U3129_GRID_COMPACT_FOOTER_ROW_PY}`;

export const U3129_GRID_COMPACT_FOOTER_LABEL_TD_BASE = `pl-3 pr-3 ${U3129_GRID_COMPACT_FOOTER_ROW_PY} text-left leading-none`;

/** Hauteur / bordure inputs en grille honoraires compacte (sans alignement texte — évite client/projet en text-right). */
export const U3129_GRID_COMPACT_TABLE_CONTROL_CLASS =
  "[&_input:not([data-u2000-skip-grid-compact])]:box-border [&_input:not([data-u2000-skip-grid-compact])]:block [&_input:not([data-u2000-skip-grid-compact])]:h-8 [&_input:not([data-u2000-skip-grid-compact])]:min-h-8 [&_input:not([data-u2000-skip-grid-compact])]:max-h-8 [&_input:not([data-u2000-skip-grid-compact])]:w-full [&_input:not([data-u2000-skip-grid-compact])]:min-w-0 [&_input:not([data-u2000-skip-grid-compact])]:rounded-lg [&_input:not([data-u2000-skip-grid-compact])]:border [&_input:not([data-u2000-skip-grid-compact])]:border-gray-300 [&_input:not([data-u2000-skip-grid-compact])]:bg-surface [&_input:not([data-u2000-skip-grid-compact])]:!px-4 [&_input:not([data-u2000-skip-grid-compact])]:!py-0.5 [&_input:not([data-u2000-skip-grid-compact])]:text-sm [&_input:not([data-u2000-skip-grid-compact])]:leading-tight [&_button:not([data-u2000-skip-grid-compact])]:h-8 [&_button:not([data-u2000-skip-grid-compact])]:min-h-8 [&_button:not([data-u2000-skip-grid-compact])]:!py-0.5";

/** Colonnes heures uniquement (U2000InputDecimal). */
export const U3129_GRID_COMPACT_DECIMAL_CONTROL_CLASS = "[&_input]:text-right [&_input]:tabular-nums";

/**
 * Honoraires — colonnes métier resserrées par défaut ; largeurs « bureau » seulement à partir de `xl` (1280px).
 * Sous xl, priorité aux colonnes jour (week-end = 7 j.) sans scroll horizontal inutile.
 */
/** Base compacte — meta resserrées pour 7 jours + total visibles sans scroll inutile. */
/** # dossier (~5 chiffres) — largeur fixe (ne varie pas avec 5 / 7 jours). */
export const U3129_HONORARIUM_COL_WIDTH_PROJECT = "5.5rem";
/** Largeur minimale client ; la colonne peut s’élargir (pas le projet) si la table a de la place. */
export const U3129_HONORARIUM_COL_WIDTH_CLIENT_MIN = "5rem";
/** Alias colgroup / calcul min table (minimum client). */
export const U3129_HONORARIUM_COL_WIDTH_CLIENT = U3129_HONORARIUM_COL_WIDTH_CLIENT_MIN;
/** Codes natures mandat (ex. CAD+PIQ+OCTR, DIV+ETUDE+PLAN). */
export const U3129_HONORARIUM_COL_WIDTH_NATURES = "12rem";
export const U3129_HONORARIUM_COL_WIDTH_SUBPROJECT = "5rem";
/** Ligne « sans projet » : colonne tâche seule (0 dans colgroup ; min-width sur la cellule éditables). */
export const U3129_HONORARIUM_COL_WIDTH_TASK_ORPHAN = "0";

export const U3129_HONORARIUM_PROJECT_COL_CLASS =
  "min-w-[5.5rem] w-[5.5rem] max-w-[5.5rem] shrink-0 grow-0 basis-[5.5rem] xl:w-[5.5rem] xl:min-w-[5.5rem] xl:max-w-[5.5rem]";
/** Client : min fixe, peut grandir ; truncate si le libellé dépasse. */
export const U3129_HONORARIUM_CUSTOMER_COL_CLASS =
  "min-w-[5rem] w-auto max-w-[8rem] xl:min-w-[5rem] xl:w-auto xl:max-w-[8rem]";
export const U3129_HONORARIUM_NATURES_COL_CLASS =
  "min-w-[12rem] w-[12rem] max-w-[18rem] shrink-0 tabular-nums xl:min-w-[12rem] xl:w-[12rem]";
export const U3129_HONORARIUM_SUBPROJECT_COL_CLASS =
  "min-w-[4rem] w-[5rem] max-w-[5rem] xl:w-[5rem] xl:min-w-[5rem] xl:max-w-[5rem]";
/** Colonne tâche — lignes « sans projet » uniquement. */
export const U3129_HONORARIUM_TASK_COL_CLASS =
  "min-w-[8rem] w-[10rem] max-w-[11rem] xl:w-[10rem] xl:min-w-[10rem] xl:max-w-[11rem]";
/** Ligne détail tâche — largeur = colspan (table-fixed), pas de max-w fixe (responsive xl). */
export const U3129_HONORARIUM_TASK_DETAIL_COLSPAN_CLASS =
  "min-w-0 w-full max-w-full box-border";
/** En-tête / cellule réservée colonne tâche orpheline (sans libellé, largeur pilotée par colgroup). */
export const U3129_HONORARIUM_TASK_ORPHAN_HEADER_CLASS = "min-w-0 w-0 max-w-0 p-0 border-0 overflow-hidden";
/** Colonne jour / total — saisie jusqu’à 3 entiers + 2 décimales (ex. « 123,45 ») avec input compact `px-4`. */
export const U3129_HONORARIUM_COL_WIDTH_HOUR = "6.5rem";
/** Pas de min-width xl large (ex. min-w-208) : sinon la table s’élargit et masque les jours. */
export const U3129_HONORARIUM_FOOTER_LABEL_COL_CLASS = "min-w-0 max-w-full";
/** Jours : largeur fixe (scroll horizontal si la grille dépasse le viewport). */
export const U3129_HONORARIUM_HOUR_COL_CLASS =
  "min-w-[6.5rem] w-[6.5rem] shrink-0 xl:min-w-[6.5rem] xl:w-[6.5rem]";

const U3129_HONORARIUM_COL_WIDTH_CHECKBOX = U3129_HONORARIUM_COL_WIDTH_GUTTER;

/** Largeur minimale de la grille honoraires (scroll horizontal plutôt que compression des jours). */
export function u3129HonorariumTableMinWidth(options: {
  showSubProjectColumn: boolean;
  dayColumnCount: number;
}): string {
  const subPart = options.showSubProjectColumn ? ` + ${U3129_HONORARIUM_COL_WIDTH_SUBPROJECT}` : "";
  const hourCols = options.dayColumnCount + 1;
  return `calc(${U3129_HONORARIUM_COL_WIDTH_CHECKBOX} + ${U3129_HONORARIUM_COL_WIDTH_PROJECT} + ${U3129_HONORARIUM_COL_WIDTH_CLIENT} + ${U3129_HONORARIUM_COL_WIDTH_NATURES}${subPart} + ${U3129_HONORARIUM_COL_WIDTH_TASK_ORPHAN} + ${hourCols} * ${U3129_HONORARIUM_COL_WIDTH_HOUR})`;
}

/** Colonne Type (libellés banque + soldes) — flexible : absorbe l’espace restant au-delà du minimum. */
export const U3129_ABSENCES_BANK_COL_WIDTH_TYPE_MIN = "17rem";

/** Colonne Type / libellés pied (une seule colonne physique — pas de colspan honoraires). */
export const U3129_ABSENCES_BANK_TYPE_COL_CLASS = "min-w-[17rem] box-border text-left";

export const U3129_ABSENCES_BANK_TYPE_TD_CLASS = `pl-2 pr-2 ${U3129_GRID_COMPACT_ROW_CELL_PY} align-top text-left ${U3129_ABSENCES_BANK_TYPE_COL_CLASS}`;

export const U3129_ABSENCES_BANK_TYPE_HEADER_TH_CLASS = `pl-2 pr-2 py-2.5 text-left font-medium text-gray-700 ${U3129_ABSENCES_BANK_TYPE_COL_CLASS}`;

export const U3129_ABSENCES_BANK_FOOTER_TYPE_TD_CLASS = `pl-2 pr-2 ${U3129_GRID_COMPACT_FOOTER_ROW_PY} text-left leading-none`;

export const U3129_ABSENCES_BANK_TYPE_LABEL_INNER_CLASS =
  "min-w-0 w-full text-left text-sm leading-snug text-gray-800 break-words";

export const U3129_ABSENCES_BANK_FOOTER_LABEL_COL_CLASS = U3129_HONORARIUM_FOOTER_LABEL_COL_CLASS;

/** Colonnes jour / Total Absences — largeur fixe (comme Honoraires), jamais étirée. */
export const U3129_ABSENCES_BANK_COL_WIDTH_HOUR = "5rem";

export const U3129_ABSENCES_BANK_HOUR_COL_CLASS = "min-w-[5rem] w-[5rem] max-w-[5rem] shrink-0 box-border";

/** En-tête colonnes jour + Total — inset aligné inputs Absences (`px-1.5`). */
export const U3129_ABSENCES_BANK_DAY_HOUR_TH_CLASS = `pl-1 pr-[calc(0.25rem+0.375rem+1px)] py-2.5 text-right text-sm tabular-nums leading-none ${U3129_ABSENCES_BANK_HOUR_COL_CLASS}`;

export const U3129_ABSENCES_BANK_HOUR_BODY_TD_CLASS = `${U3129_GRID_COMPACT_ROW_HOUR_TD_BASE} ${U3129_ABSENCES_BANK_HOUR_COL_CLASS} align-top text-right`;

const U3129_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_BASE = `pl-1 ${U3129_GRID_COMPACT_FOOTER_ROW_PY} align-top text-right text-sm tabular-nums leading-none ${U3129_ABSENCES_BANK_HOUR_COL_CLASS}`;

/** Pied colonnes heures — même logique d’inset que {@link U3129_GRID_COMPACT_HOUR_FOOTER_VALUE_TD_CLASS_READ}. */
export const U3129_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_CLASS_READ = `${U3129_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_BASE} pr-[calc(0.25rem+0.375rem+1px+1px)]`;

export const U3129_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_CLASS_EDIT = `${U3129_ABSENCES_BANK_HOUR_FOOTER_VALUE_TD_BASE} pr-[calc(0.25rem+0.375rem+1px+7px)]`;

/** Largeur minimale grille Absences et banques (scroll seulement si viewport insuffisant). */
export function u3129AbsencesBanquesTableMinWidth(options: { dayColumnCount: number }): string {
  const hourCols = options.dayColumnCount + 1;
  return `calc(${U3129_ABSENCES_BANK_COL_WIDTH_TYPE_MIN} + ${hourCols} * ${U3129_ABSENCES_BANK_COL_WIDTH_HOUR})`;
}
